export const meta = { id: 'O25', slug: 'adicionar-componentes', title: 'Como adicionar Componentes', description: 'Escolha o tipo de experiência que fará parte de cada Etapa da Formação.', profile: 'owner', category: 'formacoes', type: 'task', status: 'published', order: 550, keywords: ['componentes','treinamento','atividade prática','estudo de caso','role play','mentoria','evidência','checkpoint'], previous: 'O24', next: 'O26', related: ['O26','O27','O28','O29'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como adicionar Componentes

Os Componentes são as experiências executadas dentro de uma Etapa.

<HelpImage pendingId="O25.1" alt="Tela de criação de Componente da Formação" />

## Tipos disponíveis na versão atual

1. Treinamento
2. Atividade prática
3. Estudo de caso
4. Role play
5. Aula ao vivo
6. Mentoria
7. Evidência
8. Checkpoint

<Steps>
  <Step title="Abra a Etapa">Escolha onde a experiência deve acontecer.</Step>
  <Step title="Adicione um Componente">Selecione o tipo adequado ao objetivo.</Step>
  <Step title="Configure suas regras">Defina ordem, obrigatoriedade, duração quando aplicável e pré-requisitos.</Step>
  <Step title="Salve e revise">Confirme como o Componente aparece no currículo.</Step>
</Steps>
